/**
 * One delivery line (Bill 2026-10-06). The apartment / suite rides on the street line
 * ("2428 Lanes End Ln Apt C"), the USPS standard and the form's own convention — a
 * separate street-line-2 value was invisible on the form, ignored by the USPS check and
 * never written to Core, so a unit read or typed there was silently lost.
 */

const UNIT_WORD: Record<string, string> = {
  apartment: 'apt', apt: 'apt', suite: 'ste', ste: 'ste', unit: 'unit', lot: 'lot',
  trailer: 'trlr', trlr: 'trlr', building: 'bldg', bldg: 'bldg', floor: 'fl', fl: 'fl',
  room: 'rm', rm: 'rm', space: 'spc', spc: 'spc', department: 'dept', dept: 'dept',
  office: 'ofc', ofc: 'ofc', penthouse: 'ph', ph: 'ph',
};

const STREET_WORD: Record<string, string> = {
  street: 'st', avenue: 'ave', road: 'rd', drive: 'dr', lane: 'ln', court: 'ct',
  boulevard: 'blvd', circle: 'cir', place: 'pl', parkway: 'pkwy', highway: 'hwy',
  terrace: 'ter', trail: 'trl', square: 'sq', way: 'way', north: 'n', south: 's',
  east: 'e', west: 'w', northeast: 'ne', northwest: 'nw', southeast: 'se', southwest: 'sw',
};

/** Comparable form of a street line: lower case, no punctuation, USPS abbreviations. */
export function normalizeStreet(line: string | null | undefined): string {
  return (line ?? '')
    .toLowerCase()
    .replace(/[.,#]/g, ' ')
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => UNIT_WORD[w] ?? STREET_WORD[w] ?? w)
    .join(' ');
}

/** Street line 1 + line 2 as one delivery line; line 2 is dropped when line 1 already carries it. */
export function joinStreetLines(line1: string | null | undefined, line2: string | null | undefined): string {
  const a = (line1 ?? '').trim();
  const b = (line2 ?? '').trim();
  if (!b) return a;
  if (!a) return b;
  const na = ` ${normalizeStreet(a)} `;
  const nb = normalizeStreet(b);
  if (na.includes(` ${nb} `)) return a;
  return `${a} ${b}`;
}
